export const colors = {
  //accent = neoFontColor
  primaryColor: "#231A3D",
  accentColor: "#0054E3",
  linkColor: "#4A90E2",
  whiteColor: "#ffffff",
  blackColor: "#000000",
  defaultFontColor: "#4a4a4a",
  baseBlue: "#436AB2",
  mediumBlue: "#F4F8FF",
  cardBackgroundColor: "#F1F3F6",
  uploadFileName: "#F1EEFF",
  headerBackgroundColor: "#E5F7FF",
  neoCardBgColor: "#F2E6FE",
  neoFontColor: "#4B006D",
  newCardBgColor: "#F8EFFF",
  chipColor: "#65179A",
};

export const theme = {
  ...colors,
};
